import { render, staticRenderFns } from "./UserDataTable.vue?vue&type=template&id=fd18bf24&scoped=true&"
import script from "./UserDataTable.vue?vue&type=script&lang=js&"
export * from "./UserDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UserDataTable.vue?vue&type=style&index=0&id=fd18bf24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd18bf24",
  null
  
)

export default component.exports